// The card also shows starred / hidden events the feed doesn't hold (the profile's copies): redraw when those change.
import { useStore } from "zustand";
import { profileStore } from "../../state/profile";

export const useProfileStore = () => useStore(profileStore, (s) => s.events);
